import { Tag } from "antd"

import { Column } from "abstract/types/column.type"
import { defaultFormat } from "utils/date"

export const accountColumns = [
  {
    title: "Created At",
    dataIndex: "createdAt",
    key: "createdAt",
    render: (el: Date) => el && <Tag color="green">{defaultFormat(el)}</Tag>,
  },
  {
    title: "Is Active",
    dataIndex: "isActive",
    key: "isActive",
    render: (el: boolean) => (el ? "Yes" : "No"),
  },
  {
    title: "Active Until",
    dataIndex: "activeUntil",
    key: "activeUntil",
    render: (el: Date) => el && <Tag color="blue">{defaultFormat(el)}</Tag>,
  },
  {
    title: "Billing Plan Id",
    dataIndex: "billingPlanId",
    key: "billingPlanId",
  },
  {
    title: "Name",
    dataIndex: "name",
    key: "name",
  },
  {
    title: "Billing Period",
    dataIndex: "billingPeriod",
    key: "billingPeriod",
  },
  {
    title: "First Month Price",
    dataIndex: "price",
    key: "price",
  },
  {
    title: "Provider Name",
    dataIndex: "providerName",
    key: "providerName",
  },
]

export const transactionColumns: Column[] = [
  { title: "Amount", dataIndex: "amount", key: "amount" },
  {
    title: "Created At",
    dataIndex: "createdAt",
    key: "createdAt",
    render: (el: Date) => el && <Tag color="green">{defaultFormat(el)}</Tag>,
  },
  {
    title: "Name",
    dataIndex: "datum",
    key: "data",
    render: (props: any) => props && <Tag>{props?.name || "Noname"}</Tag>,
  },
]

export const sessionColumns: Column[] = [
  { title: "Ip Address", dataIndex: "ipAddress", key: "ipAddress" },
  {
    title: "Created At",
    dataIndex: "createdAt",
    key: "createdAt",
    render: (el: Date) => el && <Tag color="green">{defaultFormat(el)}</Tag>,
  },
  {
    title: "Country",
    dataIndex: "country",
    key: "country",
    render: (props: string) => props && <Tag>{props || "Noname"}</Tag>,
  },
]

export const itemsColumns: Column[] = [
  { title: "Code", dataIndex: "giftCode", key: "giftCode" },
  {
    title: "Purchased At",
    dataIndex: "date",
    key: "date",
    render: (el: Date) => el && <Tag color="red">{defaultFormat(el)}</Tag>,
  },
  { title: "Name", dataIndex: "name", key: "name" },
  {
    title: "Price",
    dataIndex: "price",
    key: "price",
  },
  {
    title: "Item Provider Name",
    dataIndex: "itemProviderName",
    key: "itemProviderName",
    render: (el: string) => el || "Internal",
  },
]

export const raffleTicketColumns: Column[] = [
  {
    title: "Is For Premium Only?",
    dataIndex: "isPremium",
    key: "isPremium",
    render: (el: boolean) => (el ? "Yes" : "No"),
  },
  { title: "Price", dataIndex: "price", key: "price" },
  { title: "Raffle Name", dataIndex: "name", key: "name" },
  {
    title: "Purchased At",
    dataIndex: "purchasedAt",
    key: "purchasedAt",
    render: (el: Date) => el && <Tag color="red">{defaultFormat(el)}</Tag>,
  },
]

export const lootboxColumns: any[] = [
  {
    title: "ID",
    dataIndex: "id",
    key: "id",
    sorter: (a: any, b: any) => a.id - b.id,
  },
  {
    title: "Type",
    dataIndex: "type",
    key: "type",
    sorter: (a: any, b: any) => (a.type || "").localeCompare(b.type || ""),
  },
  {
    title: "Source",
    dataIndex: "source",
    key: "source",
    sorter: (a: any, b: any) => (a.source || "").localeCompare(b.source || ""),
  },
  {
    title: "Status",
    dataIndex: "status",
    key: "status",
    sorter: (a: any, b: any) => (a.status || "").localeCompare(b.status || ""),
  },
  {
    title: "Premium Reward Types",
    dataIndex: "premiumRewardTypes",
    key: "premiumRewardTypes",
    sorter: (a: any, b: any) => {
      const aTypes = a.premiumRewardTypes || []
      const bTypes = b.premiumRewardTypes || []
      const aFirst = aTypes.length > 0 ? aTypes[0] : ""
      const bFirst = bTypes.length > 0 ? bTypes[0] : ""

      return aFirst.localeCompare(bFirst)
    },
    render: (el: string[]) => {
      if (!el || el.length === 0) {
        return "-"
      }

      return (
        <div>
          {el.map((type, index) => (
            <Tag key={index} color="purple" style={{ marginBottom: "4px" }}>
              {type}
            </Tag>
          ))}
        </div>
      )
    },
  },
  {
    title: "Reward Count",
    dataIndex: "rewardCount",
    key: "rewardCount",
    sorter: (a: any, b: any) => {
      const aCount = a.rewardCount ?? -1
      const bCount = b.rewardCount ?? -1

      return aCount - bCount
    },
    render: (el: number) => (el !== undefined ? el : "-"),
  },
  {
    title: "Obtained At",
    dataIndex: "obtainedAt",
    key: "obtainedAt",
    sorter: (a: any, b: any) => {
      const aDate = a.obtainedAt ? (typeof a.obtainedAt === "string" ? new Date(a.obtainedAt) : a.obtainedAt) : new Date(0)
      const bDate = b.obtainedAt ? (typeof b.obtainedAt === "string" ? new Date(b.obtainedAt) : b.obtainedAt) : new Date(0)

      return aDate.getTime() - bDate.getTime()
    },
    render: (el: Date | string) => {
      if (!el) {
        return "-"
      }
      const date = typeof el === "string" ? new Date(el) : el

      return <Tag color="green">{defaultFormat(date)}</Tag>
    },
  },
  {
    title: "Opened At",
    dataIndex: "openedAt",
    key: "openedAt",
    sorter: (a: any, b: any) => {
      const aDate = a.openedAt ? (typeof a.openedAt === "string" ? new Date(a.openedAt) : a.openedAt) : new Date(0)
      const bDate = b.openedAt ? (typeof b.openedAt === "string" ? new Date(b.openedAt) : b.openedAt) : new Date(0)

      return aDate.getTime() - bDate.getTime()
    },
    render: (el: Date | string) => {
      if (!el) {
        return "-"
      }
      const date = typeof el === "string" ? new Date(el) : el

      return <Tag color="blue">{defaultFormat(date)}</Tag>
    },
  },
]

export const battlePassColumns: Column[] = [
  { title: "Season", dataIndex: "season", key: "season" },
  { title: "Status", dataIndex: "status", key: "status" },
  { title: "User XP", dataIndex: "userXp", key: "userXp" },
  {
    title: "Purchased",
    dataIndex: "purchased",
    key: "purchased",
    render: (el: boolean) => (el ? <Tag color="green">Yes</Tag> : <Tag color="red">No</Tag>),
  },
  {
    title: "Start Date",
    dataIndex: "startDate",
    key: "startDate",
    render: (el: string) => el && <Tag color="green">{defaultFormat(new Date(el))}</Tag>,
  },
  {
    title: "End Date",
    dataIndex: "endDate",
    key: "endDate",
    render: (el: string) => el && <Tag color="red">{defaultFormat(new Date(el))}</Tag>,
  },
]
